import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { SeeMore, Title, Container } from './styles';

interface Props {
  title: string;
  seeMore: boolean;
  hideSeeMoreButton?: boolean;
  onToggleSeeMore: () => void;
}

const SeeMoreHeader = ({ title, hideSeeMoreButton, seeMore, onToggleSeeMore }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <Title>{title}</Title>
      {!hideSeeMoreButton && (
        <SeeMore onClick={onToggleSeeMore}>{seeMore ? t('hotelDetails.seeLess') : t('hotelDetails.seeMore')}</SeeMore>
      )}
    </Container>
  );
};

export default SeeMoreHeader;
